export const formatFileSizeForDisplay = (fileSize?: string | number): string => {
  if (!fileSize) {
    return '';
  }
  const fileSizeAsNumber =
    typeof fileSize === 'string' ? parseInt(fileSize, 10) : fileSize;
  const kilobytes = fileSizeAsNumber / 1000;
  if (kilobytes >= 1000) {
    return `${(kilobytes / 1000).toFixed(1)}MB`;
  }
  if (kilobytes >= 1) {
    return `${kilobytes.toFixed(0)}KB`;
  }
  return `${kilobytes.toFixed(1)}KB`;
};
